module.exports = __webpack_public_path__ + "static/media/acdi.ce5f4847.png";